import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { REDUCED_MOTION } from "@/App";

const EASE = [0.76, 0, 0.24, 1];

export default function Preloader() {
  const [show, setShow] = useState(() => !REDUCED_MOTION && !sessionStorage.getItem("om-intro"));
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!show) return;
    document.documentElement.style.overflow = "hidden";
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / 1400, 1);
      setCount(Math.round(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    const done = setTimeout(() => {
      sessionStorage.setItem("om-intro", "1");
      setShow(false);
      document.documentElement.style.overflow = "";
    }, 2100);
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(done);
      document.documentElement.style.overflow = "";
    };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="preloader"
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-ink"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: EASE }}
        >
          <div className="relative">
            <motion.div
              aria-hidden="true"
              className="absolute inset-0 rounded-full bg-brand/30 blur-3xl"
              initial={{ scale: 0.4, opacity: 0 }}
              animate={{ scale: 1.4, opacity: 0.8 }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            />
            <motion.img
              src="/logo-horizontal.png"
              alt="ONWARD MEDIA"
              data-testid="preloader-logo"
              className="relative h-20 w-auto sm:h-28"
              initial={{ clipPath: "inset(0 100% 0 0)", opacity: 0.6, scale: 0.96 }}
              animate={{ clipPath: "inset(0 0% 0 0)", opacity: 1, scale: 1 }}
              transition={{ duration: 1.2, ease: [0.76, 0, 0.24, 1], delay: 0.1 }}
              draggable={false}
            />
          </div>
          <motion.p
            className="mt-8 font-hindi text-2xl text-saffron sm:text-3xl"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.7 }}
          >
            आगे बढ़ो। हमेशा।
          </motion.p>
          <div className="absolute bottom-10 left-6 right-6 flex items-end justify-between lg:left-12 lg:right-12">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500">Onward Media — Indore</p>
            <p className="font-display text-6xl font-bold tabular-nums text-paper sm:text-8xl" data-testid="preloader-count">
              {count}
            </p>
          </div>
          <motion.span
            className="ribbon-gradient absolute bottom-0 left-0 h-[3px]"
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            transition={{ duration: 1.4, ease: "linear" }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
